import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS} from '../utils/logger';
import deep from 'deep-diff';
import JSON_TRANSFORM from '../utils/jsonTransform/jsonTransformers';
import xml2js from 'xml2js';

export const MODULE_NAME = 'ERROR_DOCUMENT_DETAIL_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}

const UNLOAD = namespaced('UNLOAD');
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const UPDATE = namespaced('UPDATE');
const UPDATE_PROGRESS = namespaced('UPDATE_PROGRESS');
const UPDATE_OK = namespaced('UPDATE_OK');
const UPDATE_FAIL = namespaced('UPDATE_FAIL');


export const ACTION_TYPES = {
  UNLOAD,
  LOAD,
  LOAD_OK,
  LOAD_FAIL,
  UPDATE,
  UPDATE_PROGRESS,
  UPDATE_OK,
  UPDATE_FAIL,
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case UNLOAD:
          return  Object.assign({}, state, {loading: false, error: null, data: null,  progress: undefined});
      case LOAD:
        return  Object.assign({}, state, {loading: true, error: null});
      case LOAD_OK:
        return Object.assign({}, state, {data: action.response, loading: false, error: null, progress: undefined});
      case LOAD_FAIL:
        return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
      case UPDATE:
        return  Object.assign({}, state, {loading: true, error: null, progress: action.progress});
      case UPDATE_PROGRESS:
        return  Object.assign({}, state, {error: null, progress: action.progress});
      case UPDATE_OK:
        return Object.assign({}, state, {data: undefined, loading: false, error: null});
      case UPDATE_FAIL:
        return Object.assign({}, state, {loading: false, failures: action.failures});
      case '@@router/LOCATION_CHANGE':
        //TODO: This is brutal but required because of blocking updates on sub-component
        // https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
        return  {data: undefined, loading: false, error: undefined};
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

export const API = {
  doLoad: (id, callback=()=>{}, featureFlags = []) => {
    return (dispatch, getState) => {
      dispatch({type: LOAD});
      log.debug('doLoad():', id );
      CLIENT.getErrorDocument(id, featureFlags)
        .then((response) => {
          log.debug('doLoad(): succeeded: ', response);
          dispatch({type: LOAD_OK, response: response});
          callback(null, {});
        })
        .catch((error) => {
          log.debug('doLoad(): failed: ', error);
          dispatch({type: LOAD_FAIL, error});
          callback(error, null);
        });
    }
  },

  doUnLoad: (id, callback=()=>{}) => {
    return (dispatch, getState) => {
      dispatch({type: UNLOAD})
    }
  },

  doReprocessError: (formData, callback=()=>{}) => {

    log.debug('doReprocessError controller: formData: ', formData);

    const whatChanged = deep(formData.initialValues, formData.fieldValues);
    log.debug('doReprocessError controller: whatChanged: ', whatChanged);

    let changesList = [];

    whatChanged.map((diffItem, index) => {
      let itemCurrentValue = diffItem.lhs;
      let itemNewValue = diffItem.rhs;
      let jsonPath = JSON_TRANSFORM.arrayToFlatReference(diffItem.path);
      let shortPath = jsonPath.substring(jsonPath.indexOf("ReportingDocument"));

      let change = {
        "tagName": shortPath,
        "oldValue": itemCurrentValue,
        "newValue": itemNewValue
      };

      log.debug('doReprocessError controller: change: ', change);
      changesList.push(change);

    });

    // Convert the current state from structured object back to XML
    let builder = new xml2js.Builder({rootName: 'ReportingDocument', headless:true, renderOpts: {'pretty': false}});
    let xmlReportingDocument = builder.buildObject(formData.structured.errorJson.ReportingDocument);
    let body = { "newXml": xmlReportingDocument, "changeLog": changesList };

    return (dispatch, getState) => {
      dispatch({type: UPDATE});
      CLIENT.doErrorReplaceXML(formData.structured.id, body)
        .then((response) => {
          log.debug('doErrorsActionMove from errorDocumentDetail controller: ', response);
          dispatch({type: UPDATE_OK, response: response});
          callback(null, response);
        })
        .catch((error) => {
          log.debug('doErrorsActionMove from errorDocumentDetail controller: ', error);
          dispatch({type: UPDATE_FAIL, error});
          callback(error, null);
        });
    }
  }
};

export default API;